<style scoped lang="scss">
    @import "../../styles/mixins";
    @import "../../styles/var";

    .upload-icon {
        @include w_h(80px);
        line-height: 80px;
        text-align: center;
        border: 1px solid #999999;
        border-radius: 1px;
        font-size: 34px;
    }

    .piclist {
        img {
            @include w_h(80px);
        }
    }

</style>

<template>
    <div>
        <hos_apply_title title="病情资料"></hos_apply_title>
        <el-form ref="form" :model="form" class="mt20" label-position="left" label-width="80px" :rules="diseaseRule" size="mini">
            <el-form-item label="主诉" prop="consultContent">
                <v-textarea placeholder="请输入主诉" :readonly="readonly&&needOpen===false"
                            v-model="form.consultContent"></v-textarea>
            </el-form-item>
            <el-form-item label="初步诊断" prop="beforeDiagnose">
                <v-textarea placeholder="请输入初步诊断" :readonly="readonly&&needOpen===false"
                            v-model="form.beforeDiagnose" :maxlength="100"></v-textarea>
            </el-form-item>
            <el-form-item prop="consultReason">
                <div slot="label" style="line-height: 20px">申请会诊目的（或事由）</div>
                <v-textarea :readonly="readonly&&needOpen===false" v-model="form.consultReason"
                            placeholder="请输入申请会诊目的（或事由）" :maxlength="50"></v-textarea>
            </el-form-item>
            <el-form-item label="病历附件" label-width="80px">
                <concul_file_load ref="load" :picList="picList" :filelist="fileList"></concul_file_load>
                <!--<el-upload v-if="readonly===false||needOpen" class="mt10"-->
                           <!--accept="image/*"-->
                           <!--list-type="picture-card"-->
                           <!--:on-error="uploadOnError"-->
                           <!--:on-change="uploadOnChange1"-->
                           <!--:on-remove="uploadOnChange1"-->
                           <!--:on-exceed="onExceed"-->
                           <!--:action="API_URL"-->
                           <!--:limit="9"-->
                           <!--:file-list="picList"-->
                           <!--:data="upload1"-->
                           <!--:headers="UPLOAD_HEADERS">-->
                    <!--<i class="el-icon-plus"></i>-->
                    <!--<div class="fs14 color_333" slot="tip">-->
                        <!--最多可上传9张图片，支持jpg、png、gif、bmp、PDF格式。-->
                    <!--</div>-->
                <!--</el-upload>-->
                <!--<el-upload v-if="readonly===false||needOpen"-->
                           <!--ref="upload2"-->
                           <!--:action="API_URL"-->
                           <!--:file-list="fileList"-->
                           <!--:data="upload2"-->
                           <!--:on-success="onSuccess"-->
                           <!--:on-error="uploadOnError"-->
                           <!--:on-change="uploadOnChange2"-->
                           <!--:on-remove="uploadOnChange2"-->
                           <!--:before-upload="beforeUpload2"-->
                           <!--:headers="UPLOAD_HEADERS">-->
                    <!--<el-button size="medium">添加附件</el-button>-->
                    <!--<div slot="tip" class="fs14 color_333">-->
                        <!--仅支持pdf、xls、xlsx、doc、docx、txt、rar、zip格式，文件小于500M。-->
                    <!--</div>-->
                <!--</el-upload>-->
            </el-form-item>
        </el-form>
        <!--<v-title title="简要病史（申请医生填写）" style="margin-left: -15px"></v-title>-->
        <!--<el-form ref="form" :model="form" label-width="70px" label-position="left" size="mini">-->
            <!--<el-form-item label="主诉">-->
                <!--<v-textarea placeholder="请输入主诉" :readonly="readonly&&needOpen===false"-->
                            <!--v-model="form.consultContent"></v-textarea>-->
            <!--</el-form-item>-->
            <!--<el-form-item label="初步诊断">-->
                <!--<v-textarea placeholder="请输入初步诊断" :readonly="readonly&&needOpen===false"-->
                            <!--v-model="form.beforeDiagnose" :maxlength="100"></v-textarea>-->
            <!--</el-form-item>-->
            <!--<el-form-item>-->
                <!--<div class="" slot="label" style="line-height: 20px">申请会诊目的（或事由）</div>-->
                <!--<v-textarea :readonly="readonly&&needOpen===false" v-model="form.consultReason"-->
                            <!--placeholder="请输入申请会诊目的（或事由）" :maxlength="50"></v-textarea>-->
            <!--</el-form-item>-->
            <!--<el-form-item label="病历资料">-->
                <!--<div>-->
                    <!--<div class="flex"><span class="app_btn_main">电子病历</span></div>-->
                    <!--<template v-if="readonly&&needOpen===false">-->
                        <!--<ul class="piclist flex pt5">-->
                            <!--<li v-for="(data,index) in picList" @click="scan(index,picList)" class="mr5 mb5">-->
                                <!--<img :src="data.url" alt="">-->
                            <!--</li>-->
                        <!--</ul>-->
                        <!--<div class="flex"><span class="app_btn_main">附件</span></div>-->
                        <!--<ul class="filelist">-->
                            <!--<li v-for="(data,index) in fileList" class="fs12">-->
                                <!--<a :href="data.url" class="color_999" :download="data.name">{{data.name}}</a>-->
                            <!--</li>-->
                        <!--</ul>-->
                    <!--</template>-->
                    <!--<el-upload v-if="readonly===false||needOpen" class="mt10"-->
                               <!--accept="image/*"-->
                               <!--list-type="picture-card"-->
                               <!--:on-error="uploadOnError"-->
                               <!--:on-change="uploadOnChange1"-->
                               <!--:on-remove="uploadOnChange1"-->
                               <!--:on-exceed="onExceed"-->
                               <!--:action="API_URL"-->
                               <!--:limit="9"-->
                               <!--:file-list="picList"-->
                               <!--:data="upload1"-->
                               <!--:headers="UPLOAD_HEADERS">-->
                        <!--<i class="el-icon-plus"></i>-->
                        <!--<div class="fs14 color_333" slot="tip">-->
                            <!--最多可上传9张图片，支持jpg、png、gif、bmp、PDF格式。-->
                        <!--</div>-->
                    <!--</el-upload>-->
                    <!--<el-upload v-if="readonly===false||needOpen"-->
                               <!--ref="upload2"-->
                               <!--:action="API_URL"-->
                               <!--:file-list="fileList"-->
                               <!--:data="upload2"-->
                               <!--:on-success="onSuccess"-->
                               <!--:on-error="uploadOnError"-->
                               <!--:on-change="uploadOnChange2"-->
                               <!--:on-remove="uploadOnChange2"-->
                               <!--:before-upload="beforeUpload2"-->
                               <!--:headers="UPLOAD_HEADERS">-->
                        <!--<el-button size="small" type="primary">添加附件</el-button>-->
                        <!--<div slot="tip" class="fs14 color_333">-->
                            <!--仅支持pdf、xls、xlsx、doc、docx、txt、rar、zip格式，文件小于500M。-->
                        <!--</div>-->
                    <!--</el-upload>-->
                <!--</div>-->
            <!--</el-form-item>-->
        <!--</el-form>-->
        <!--<pic-scan ref="scan"></pic-scan>-->
    </div>
</template>

<script>
  import VTitle from "../common/v-title";
  import VTextarea from "../common/v-textarea";
  import {UploadMixin} from "../../lib/mixins/upload";
  import PicScan from "../common/pic-scan";
  import hos_apply_title from "../../components/hos/hos-apply-title"
  import {diseaseRule} from "../../lib/hos/until"
  import {pickByArray} from "../../lib/utils"
  import concul_file_load from "../../components/consultation/concul-file-load"

  export default {
    name: "casultation-history-form",
    components: {PicScan, VTextarea, VTitle,hos_apply_title,concul_file_load},
    props: {
      readonly: {
        type: Boolean,
        default: false
      },
      aspectUser: String,
      value: {
        type: Object,
        default: () => {
          return {};
        }
      },
      pic: Array,
      file: Array
    },
    data() {
      return {
        picList: [],
        fileList: [],
        form: {
          consultContent: '',
          beforeDiagnose: '',
          consultReason: ''
        },
          diseaseRule
      }
    },
    computed: {
      upload1() {
        return {...this.UPLOAD_PARAMS, fileType: 'IMAGE', module: 'BASE'};
      },
      upload2() {
        return {...this.UPLOAD_PARAMS, fileType: 'OTHER', module: 'BASE'};
      },
      needOpen() {
        const {consultStatus, auditStatus} = this.value;
        if (this.aspectUser === 'accept') return false;
        else if (auditStatus === true) return false;
        else if (consultStatus === 'GOING' && auditStatus === false) {
          return true;
        }
        return false;
      }

    },
    mixins: [UploadMixin],
    watch: {
      value: {
        handler(newV) {
          this.form = Object.assign({}, this.form, newV);
        },
        deep: true
      },
      pic(newV) {
        this.picList = newV;
        this.form.picList = newV.map(r => {
          return r.id;
        })
      },
      file(newV) {
        this.fileList = newV;
        this.form.attaIdList = newV.map(r => {
          return r.id;
        })
      }
    },
    methods: {
      scan(index, list) {
        this.$refs.scan.show(index, [...list].map(r => r.url));
      },
      getForm() {
          let vail = true;
          this.$refs['form'].validate((valid) => {
              if (!valid) {
                  vail = false
                  return false;
              }
          });
          let attList = this.$refs['load'].getAttaList();
          this.$set(this.form, 'picList', attList.picList);
          this.$set(this.form, 'attaIdList', attList.fileList);

          return {form:this.form,vail:vail};
      },
      uploadOnChange1(file, fileList) {
        this.picList = fileList.map(r => {
          if (r.response && r.response.code === '0') {
            r.url = r.response.obj.attaFileUrl;
            r.id = r.response.obj.id;
          }
          return r;
        });
        this.$set(this.form, 'picList', this.picList.map(r => r.id));
      },
      uploadOnChange2(file) {
        const {response, raw, name} = file;
        if (response) {
          if (response.code === '0') {
            this.fileList.push({
              name, raw, url: response.obj.attaFileUrl, id: response.obj.id
            });
            this.$set(this.form, 'attaIdList', this.fileList.map(r => r.id));
          }
        }
      },
        setAgainData(){//noremove
            const cache = this.$cache.get('consultationOrderCache');
            this.picList = cache.picList;
            this.fileList = cache.attaList;
            let consultationOrder = {...pickByArray(cache.consultGroup, ['consultContent','beforeDiagnose','consultReason'])}
            this.$nextTick(() => {
                this.form = Object.assign({},this.form,consultationOrder);
            })
        }
    },
      created() {
          const {meta, query} = this.$route;
          //是否是再次申请
          if(query.again){
              this.setAgainData();//设置缓存数据
          }
      }
  }
</script>
